import { render, staticRenderFns } from "./KeepingCompany.vue?vue&type=template&id=064d65d5&"
import script from "./KeepingCompany.vue?vue&type=script&lang=ts&"
export * from "./KeepingCompany.vue?vue&type=script&lang=ts&"
import style0 from "./KeepingCompany.vue?vue&type=style&index=0&id=064d65d5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports